import { useUpdateScheduledPost } from 'hooks/queries/scheduledPosts/useUpdateScheduledPost'
import { useDebouncedCallback } from '@react-hookz/web'
import type { ScheduledPostShow, EmailPostSettings } from 'api/clients/ScheduledPostsClient'

export const useEmailAudience = (scheduledPost: ScheduledPostShow | undefined) => {
  const updateScheduledPost = useUpdateScheduledPost({ suppressToast: true })

  const handleUpdateAudience = (listId: string) => {
    if (!scheduledPost) return

    const currentSettings = (scheduledPost.post_settings as EmailPostSettings) || {}
    updateScheduledPost.mutate({
      id: scheduledPost.id,
      params: { postSettings: { ...currentSettings, list_id: listId } },
    })
  }

  const debouncedUpdateAudience = useDebouncedCallback(
    (listId: string) => {
      handleUpdateAudience(listId)
    },
    [handleUpdateAudience],
    500,
  )

  const listId = (scheduledPost?.post_settings as EmailPostSettings)?.list_id

  return {
    listId,
    handleUpdateAudience: debouncedUpdateAudience,
  }
}
